import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import './styles.scss'
import React, { useState } from 'react'
import moment from 'moment'
import { SingleDatePicker } from 'react-dates'

const returnYears = (limitYear, maxYears) => {
  let years = []
  for (let i = moment().year() - maxYears; i <= moment().year() + limitYear; i++) {
    years.push(
      <option key={i} value={i}>
        {i}
      </option>
    )
  }
  return years
}

const renderMonthElement = ({ month, onMonthSelect, onYearSelect, limitYear = 1, maxYears = 0 }) => (
  <div style={{ display: 'flex', justifyContent: 'center' }}>
    <div className='DayPickerNavigation_button__default CalendarMonth_caption__month_picker'>
      <select value={month.month()} onChange={(e) => onMonthSelect(month, parseInt(e.target.value, 10))}>
        {moment.months().map((label, value) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
    </div>
    <div className='DayPickerNavigation_button__default CalendarMonth_caption__year_picker'>
      <select value={month.year()} onChange={(e) => onYearSelect(month, parseInt(e.target.value, 10))}>
        {returnYears(limitYear, maxYears)}
      </select>
    </div>
  </div>
)

// eslint-disable-next-line react/display-name
export default (props) => {
  const [focused, setFocused] = useState(null)
  const { name, value, handleChange, placeholder, limitYear, maxYears, ...rest } = props

  return (
    <SingleDatePicker
      date={value || null} // momentPropTypes.momentObj or null
      onDateChange={(date) => handleChange({ [name]: date && moment(date).format('YYYY-MM-DD') })} // PropTypes.func.isRequired
      focused={focused} // PropTypes.bool
      onFocusChange={({ focused }) => setFocused(focused)} // PropTypes.func.isRequired
      hideKeyboardShortcutsPanel={true}
      numberOfMonths={1}
      transitionDuration={0}
      showClearDate
      renderMonthElement={(properties) => renderMonthElement({ ...properties, limitYear, maxYears })}
      placeholder={placeholder || 'Fecha'}
      {...rest}
    />
  )
}
